import { Injectable } from '@angular/core';
import { WidgetsContainerAbstract } from 'src/app/abstract/widgets/widgets-container.abstract';
import { WidgetsAbstract } from 'src/app/abstract/widgets/widgets.abstract';
import { WidgetsFormModel } from 'src/app/models/widgets/widgets-form.model';
import { Logger } from 'src/app/core/logger';
@Injectable({
  providedIn: 'root',
})
export class WidgetsDragAndDropService {

  // List of ids of widgets that accept other widgets to be dropped inside
  private dropListIds: string[] = [];

  constructor(
    private logger: Logger) {
      // Empty
  }

  /**
   * Extract from new layout root the ids of the containers for drag & drop
   *
   * @param newLayoutRoot The new layout
   */
  public rebuildDropListIds(newLayoutRoot: WidgetsFormModel) {
    //  this.printDroppedIds("DropList (old):");
    const oldDropListIds = this.getDroppedIds();

    // Rebuild the list of droppable widgets from the new layout
    const newDropListIds: string[] = [];
    // const newKeyListIds : string[] = [];
    this.getContainerList(newDropListIds, newLayoutRoot);
    this.setDroppedIds(newDropListIds);
    // this.getDataPointsList(newKeyListIds, layoutRoot).then(() => {
    //   this.logger.debug("KeyListIds=["+newKeyListIds.toString()+"]");
    //   });
    // this.printDroppedIds("DropList (new):");
  }

  public getDroppedIds(): string[] {
    return this.dropListIds;
  }

  public setDroppedIds(idList: string[]) {
    this.dropListIds = idList;
  }

  private printDroppedIds(title: string) {
    const shortIds: string[] = [];
    this.dropListIds.forEach((id) => {
      shortIds.push(id.substring(33));
    });
    this.logger.debug(title + ": ["+shortIds.length+"]: ["+shortIds.toString()+ "]");
  }

  private addDroppedId(id: string) {
    this.dropListIds.push(id);
  }

  private async getContainerList(
    containerList: string[],
    widget: WidgetsAbstract
  ): Promise<void> {
    if (!containerList)
      {return;}

    if (widget instanceof WidgetsContainerAbstract) {
      const container = widget as WidgetsContainerAbstract;
      // Insert at the beginning of the array
      containerList.unshift(container.id);
      container.children.forEach((childWidget) => {
        this.getContainerList(containerList, childWidget);
      });
    }
  }
}
